import { render, staticRenderFns } from "./AddOnList.vue?vue&type=template&id=b6d882f0&scoped=true"
import script from "./AddOnList.vue?vue&type=script&lang=js"
export * from "./AddOnList.vue?vue&type=script&lang=js"
import style0 from "./AddOnList.vue?vue&type=style&index=0&id=b6d882f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d882f0",
  null
  
)

export default component.exports